<script module lang="ts">
  let text = $state({ current: 'Loading Passkey Verification...' });

  export const changePasskeyPromptText = (_text: string) => {
    text.current = _text;
  };
</script>

<script lang="ts">
  import BrandedSpinner from '$components/branded-spinner/BrandedSpinner.svelte';
  import ModalSimple from '$components/modal/ModalSimple.svelte';
  import { onDestroy } from 'svelte';
  import { getBottomSheetData } from '$components/bottom-sheet/index.svelte';

  onDestroy(() => {
    changePasskeyPromptText('Loading Passkey Verification...');
  });
</script>

<ModalSimple>
  {#snippet paragraph()}
    <div class="text-center">
      <div class="relative h-[100px]">
        <BrandedSpinner />
      </div>
      {#if getBottomSheetData()?.prompt}
        <p class="mb-4">{getBottomSheetData()?.prompt}</p>
      {/if}
      <p class="mb-4">{text.current}</p>
    </div>
  {/snippet}
</ModalSimple>
